/**
 * Product card event countdown: server-skew clock per badge, single shared ticker, liveBadges splice on end.
 */
(function () {
  var DAY_MS = 86400000;
  var HOUR_MS = 3600000;

  /** @type {{ el: HTMLElement, span: HTMLElement, startMs: number, endMs: number, srvMs: number, clientAt: number, tz: string, lblPre: string, lblDur: string, locale: string }[]} */
  var liveBadges = [];
  var tickTimer = null;

  function normalizeIso(str) {
    if (!str) return '';
    var t = String(str).trim();
    if (!t) return '';
    var m = t.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?)(.*?)$/);
    if (m) {
      var rest = String(m[3] || '').trim();
      var off = /^[+\-]|^[zZ]/.test(rest) ? rest : '';
      return m[1] + 'T' + m[2] + off;
    }
    return t;
  }

  function parseInstant(attr) {
    var ms = Date.parse(normalizeIso(attr || ''));
    return isNaN(ms) ? NaN : ms;
  }

  function pad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /** @param {number} msRemain Positive milliseconds */
  function formatHMS(msRemain) {
    var secTotal = Math.max(0, Math.floor(msRemain / 1000));
    var h = Math.floor(secTotal / 3600);
    var m = Math.floor((secTotal % 3600) / 60);
    var s = secTotal % 60;
    if (h > 0) {
      return h + ':' + pad2(m) + ':' + pad2(s);
    }
    return pad2(m) + ':' + pad2(s);
  }

  /**
   * Remaining time with day/hour/minute units.
   * Examples: 0d:05h:30m (under 24h), 2d:20h:25m (multi-day).
   */
  function formatDHM(msRemain) {
    var ms = Math.max(0, msRemain);
    var secTotal = Math.floor(ms / 1000);
    var d = Math.floor(secTotal / 86400);
    var h = Math.floor((secTotal % 86400) / 3600);
    var m = Math.floor((secTotal % 3600) / 60);
    return d + 'd:' + pad2(h) + 'h:' + pad2(m) + 'm';
  }

  function formatAbsolute(epochMs, timeZone, locale) {
    try {
      var loc = locale || undefined;
      var opts = {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      };
      if (timeZone) opts.timeZone = timeZone;
      return new Intl.DateTimeFormat(loc, opts).format(new Date(epochMs));
    } catch (_e) {
      try {
        return new Intl.DateTimeFormat(locale, {
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit',
        }).format(new Date(epochMs));
      } catch (_e2) {
        return '';
      }
    }
  }

  function clearSpan(span) {
    if (!span) return;
    while (span.firstChild) {
      span.removeChild(span.firstChild);
    }
    span.textContent = '';
  }

  function isMobileTimerLayout() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  /**
   * Two-line label for small screens: "Start in" / "9:12:20" (desktop stays one string).
   */
  function splitMobileLines(txt, opts) {
    opts = opts || {};
    if (!txt || typeof txt !== 'string') return null;
    var t = txt.trim();
    var m;
    m = /^Starts in (.+)$/i.exec(t);
    if (m) return ['Start in', m[1].trim()];
    m = /^Ends in (.+)$/i.exec(t);
    if (m) return ['End in', m[1].trim()];
    if (/^\d+d:\d{2}h:\d{2}m$/.test(t)) return ['End in', t];
    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(t)) return ['End in', t];
    if (opts.lblDur && t.indexOf(opts.lblDur) === 0) {
      var rest = t.slice(opts.lblDur.length).trim();
      if (rest) return [opts.lblDur, rest];
    }
    if (/^Starts soon$/i.test(t)) return null;
    if (/^Starts\s+/i.test(t) && !/^Starts in /i.test(t)) {
      var tail = t.replace(/^Starts\s+/i, '').trim();
      if (tail) return ['Starts', tail];
    }
    return null;
  }

  function writeBadgeText(span, txt, opts) {
    if (!span) return;
    clearSpan(span);
    if (!txt) return;
    var pair = isMobileTimerLayout() ? splitMobileLines(txt, opts) : null;
    if (pair && pair[0] != null && pair[1] != null) {
      var rowL = document.createElement('span');
      rowL.className = 'event-timer-badge__row event-timer-badge__row--label';
      rowL.textContent = pair[0];
      var rowT = document.createElement('span');
      rowT.className = 'event-timer-badge__row event-timer-badge__row--time';
      rowT.textContent = pair[1];
      span.appendChild(rowL);
      span.appendChild(rowT);
    } else {
      span.textContent = txt;
    }
  }

  function nowForBadge(b) {
    return b.srvMs + (Date.now() - b.clientAt);
  }

  function teardownAt(i) {
    if (i < 0 || i >= liveBadges.length) return;
    var b = liveBadges[i];
    liveBadges.splice(i, 1);
    try {
      b.el.setAttribute('hidden', '');
      b.el.hidden = true;
      clearSpan(b.span);
      b.el.classList.remove('event-timer-badge--pre', 'event-timer-badge--live');
      b.el.setAttribute('data-event-timer-done', '');
    } catch (_e) {}
  }

  /** Updates one badge instance; callers iterate backwards after splices */
  function updateOne(b, i) {
    if (!b.el.isConnected || !document.contains(b.el)) {
      liveBadges.splice(i, 1);
      return;
    }

    var now = nowForBadge(b);
    if (now >= b.endMs) {
      teardownAt(i);
      return;
    }

    var txt = '';
    var pre = false;
    var live = false;

    if (now < b.startMs) {
      var remainStart = Math.max(0, b.startMs - now);
      pre = true;
      if (b.lblPre) {
        txt = b.lblPre;
      } else if (remainStart > 7 * DAY_MS) {
        var abs = formatAbsolute(b.startMs, b.tz, b.locale);
        txt = abs ? 'Starts ' + abs : 'Starts soon';
      } else if (remainStart >= HOUR_MS) {
        txt = 'Starts in ' + formatDHM(remainStart);
      } else {
        txt = 'Starts in ' + formatHMS(remainStart);
      }
    } else {
      live = true;
      var remainEnd = Math.max(0, b.endMs - now);
      if (remainEnd < HOUR_MS) {
        txt = formatHMS(remainEnd);
      } else {
        var endFmt = formatDHM(remainEnd);
        txt = b.lblDur ? b.lblDur + ' ' + endFmt : 'Ends in ' + endFmt;
      }
    }

    b.el.removeAttribute('hidden');
    b.el.hidden = false;
    var splitOpts =
      live && b.lblDur
        ? {
            lblDur: b.lblDur,
          }
        : {};
    writeBadgeText(b.span, txt, splitOpts);
    b.el.classList.toggle('event-timer-badge--pre', pre);
    b.el.classList.toggle('event-timer-badge--live', live);
  }

  function tickAll() {
    if (!liveBadges.length) {
      if (tickTimer != null) {
        clearInterval(tickTimer);
        tickTimer = null;
      }
      return;
    }
    for (var i = liveBadges.length - 1; i >= 0; i--) {
      updateOne(liveBadges[i], i);
    }
  }

  function ensureTick() {
    if (tickTimer != null) return;
    tickTimer = setInterval(tickAll, 1000);
  }

  function bindEl(el) {
    if (el.getAttribute('data-event-timer-initialized') === '1') return;
    if (el.getAttribute('data-event-timer-done') != null) return;

    var startMs = parseInstant(el.getAttribute('data-start-iso'));
    var endMs = parseInstant(el.getAttribute('data-end-iso'));
    var srvMs = parseInstant(el.getAttribute('data-now-iso'));
    if (!isNaN(startMs) && !isNaN(endMs) && endMs < startMs) {
      var swapT = startMs;
      startMs = endMs;
      endMs = swapT;
    }
    if (isNaN(startMs) || isNaN(endMs) || isNaN(srvMs) || endMs <= startMs) return;

    var span = el.querySelector('.event-timer-badge__text');
    if (!span) return;

    el.setAttribute('data-event-timer-initialized', '1');

    var lblPre = el.getAttribute('data-label-pre') || '';
    var lblDur = el.getAttribute('data-label-during') || '';
    var tz = el.getAttribute('data-display-timezone') || 'UTC';

    /** @type {typeof liveBadges[0]} */
    var b = {
      el: el,
      span: span,
      startMs: startMs,
      endMs: endMs,
      srvMs: srvMs,
      clientAt: Date.now(),
      tz: tz,
      lblPre: lblPre,
      lblDur: lblDur,
      locale: (typeof document.documentElement.lang === 'string' && document.documentElement.lang) ? document.documentElement.lang.replace('_', '-') : undefined,
    };

    liveBadges.push(b);

    /** immediate expiry */
    var ix = liveBadges.length - 1;
    if (nowForBadge(b) >= endMs) {
      teardownAt(ix);
      return;
    }
    updateOne(b, ix);
    ensureTick();
  }

  function init(scope) {
    var root = scope && scope.nodeType === 9 ? scope : scope && scope.querySelectorAll ? scope : document;
    var list =
      typeof root.querySelectorAll === 'function'
        ? root.querySelectorAll('[data-event-timer]:not([data-event-timer-initialized="1"]):not([data-event-timer-done])')
        : [];
    Array.prototype.forEach.call(list, function (el) {
      bindEl(el);
    });
  }

  function onReady() {
    init(document);
    try {
      var mq = window.matchMedia('(max-width: 749px)');
      if (mq && mq.addEventListener) mq.addEventListener('change', tickAll);
      else if (mq && mq.addListener) mq.addListener(tickAll);
    } catch (_e) {}
  }

  function onSectionLoad(ev) {
    var t = ev && ev.target;
    if (!t || !t.querySelectorAll) {
      init(document);
      return;
    }
    init(t);
    tickAll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();

  document.addEventListener('shopify:section:load', onSectionLoad);
})();
